import { ViewModel,View, ObservableArray } from "binder"
import  { RequestsView } from "./requests-view"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IRequest } from "../IRequest";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { Enum, IEnumTranslator } from "uicomponents";
import { TranslatorConverter } from "src/TranslatorConverter";

export class RequestsViewModel extends ViewModel implements IRequest{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.title = 'درخواست های وارده';
        this.items = ObservableArray.create<singleRequest>();
        this.statusEnumProvider = new StatusEnum();
    }

    GetDefaultView(): View <ViewModel> {
        return new RequestsView();
    }
    public getTypeId(): string {
        return "VM-6B6EB41D-356D-482C-AE15-801AFC2746B2"
    }
    public set statusEnumProvider(v: StatusEnum) { this._statusEnumProvider = v; } public get statusEnumProvider(): StatusEnum { return this._statusEnumProvider;} private _statusEnumProvider: StatusEnum;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set items(v: ObservableArray<singleRequest>) { this._items = v; } public get items(): ObservableArray<singleRequest> { return this._items;} private _items: ObservableArray<singleRequest>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async refresh(): Promise<any> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/ListReceivedDistrictDebtTransfers',{

            });
            this.items.update(...result.Transfers.map((x,i)=>{
                let r = new singleRequest(this);
                r.index = i+1;
                r.id = x.Id;
                r.amount = x.Amount;
                r.creationTime = x.CreationTime
                r.confirmationTime = x.ConfirmationTime==null ? null : moment.utc(x.ConfirmationTime)
                r.confirmerName = x.ConfirmerName
                r.creatorName = x.CreatorName
                r.status = x.IsConfirmed == null ? 0 : x.IsConfirmed==true ? 1 : -1;
                r.districtName = x.FromDistrict;
                r.canChangeStatus = x.IsConfirmed == null ? true:false;
                r.comment = x.Comment;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }    
    }

    async confirm(request:singleRequest){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/ConfirmDistrictDebtTransfer',{
                Id : request.id
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess("عملیات موفق","عملیات موفق");
                this.refresh();
                this.isLoading = false;
            }else{
                this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            }
        } catch (ex) {
            this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            console.log(ex);
        } finally {
        }
    }
    async reject(request:singleRequest){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/RejectDistrictDebtTransfer',{
                Id : request.id
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess("عملیات موفق","عملیات موفق");
                this.refresh();
                this.isLoading = false;
            }else{
                this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            }
        } catch (ex) {
            this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            console.log(ex);
        } finally {
        }
    }
}


export class singleRequest extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:RequestsViewModel) {
        super(parent);
        this.tyepdParent = parent;
    }

    private tyepdParent:RequestsViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set amount(v: number) { this._amount = getAsNumber(v,true); } public get amount(): number { return this._amount;} private _amount: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set confirmationTime(v: moment.Moment) { this._confirmationTime = v; } public get confirmationTime(): moment.Moment { return this._confirmationTime;} private _confirmationTime: moment.Moment;
    public set confirmerName(v: string) { this._confirmerName = v; } public get confirmerName(): string { return this._confirmerName;} private _confirmerName: string;
    public set creatorName(v: string) { this._creatorName = v; } public get creatorName(): string { return this._creatorName;} private _creatorName: string;
    public set status(v: number) { this._status = v; } public get status(): number { return this._status;} private _status: number;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set canChangeStatus(v: boolean) { this._canChangeStatus = v; } public get canChangeStatus(): boolean { return this._canChangeStatus;} private _canChangeStatus: boolean;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    
    async confirm(){
        this.tyepdParent.confirm(this);
    }
    async reject(){
        this.tyepdParent.reject(this);
    }
}

export class StatusEnum extends Enum implements IEnumTranslator{
    
    constructor() {
        super();
        this.values = [-1,0,1];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;

    GetString(value: any) {
        return this.converter.translateDistrictTransferStatus(value);
    }

}